<template>
  <div class="flex items-center">
    <label
      :for="id"
      :class="{ 'opacity-50 cursor-not-allowed': disabled }"
      class="flex items-center cursor-pointer"
    >
      <!-- toggle -->
      <div class="relative">
        <!-- input -->
        <input
          type="checkbox"
          :id="id"
          class="sr-only"
          :disabled="disabled"
          v-model="toggleState"
        />
        <!-- line -->
        <div class="block bg-gray-300 w-14 h-8 rounded-full border"></div>
        <!-- dot -->
        <div
          class="dot absolute left-0.5 top-0.5 bg-white w-6 h-6 rounded-full transition shadow-sm"
        ></div>
      </div>
      <!-- label -->
      <div class="ml-3">
        <slot></slot>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "ToggleButtonComponent",
  props: ["state", "disabled"],
  data() {
    return {
      id: null
    };
  },

  created() {
    this.id = 'toggleB' + Math.random().toString(5);
  },

  computed: {
    toggleState: {
      get() {
        return this.state;
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  }
};
</script>

<style>
input:checked ~ .dot {
  transform: translateX(100%);
  background-color: #f75f39;
}
</style>
